"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports.buildPriceQuantityView = exports.CardTextDetail = exports.ProductDetailsCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _containers = require("../containers");

var _spacers = require("../spacers");

var _rowCard = _interopRequireDefault(require("./rowCard"));

var _cards = require("../../styles/cards");

var _theme = _interopRequireDefault(require("../../styles/theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var getFormattedCurrency = function getFormattedCurrency(number) {
  var formattedNumber = (Math.round(number * 100) / 100).toFixed(2);
  return "P" + formattedNumber.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
};

var buildPriceQuantityView = function buildPriceQuantityView(currentPrice, quantity, originalPrice, percentDiscount, shouldShowQuantity) {
  if (shouldShowQuantity === void 0) {
    shouldShowQuantity = true;
  }

  var quantityUnit = "pc";
  var quantityUnitPlural = "pcs";
  var formattedPrice = getFormattedCurrency(currentPrice);
  var formattedOrigPrice = getFormattedCurrency(originalPrice);
  return /*#__PURE__*/_react["default"].createElement(_containers.FlexColumn, {
    justifyContent: "flex-start",
    alignItems: "flex-end",
    width: "auto"
  }, percentDiscount ? /*#__PURE__*/_react["default"].createElement(_containers.FlexColumn, {
    alignItems: "flex-end"
  }, /*#__PURE__*/_react["default"].createElement(_cards.FoldingRow, null, /*#__PURE__*/_react["default"].createElement(_cards.CardText, {
    lineHeight: 1
  }, /*#__PURE__*/_react["default"].createElement(_cards.CardText, {
    size: "1.6rem",
    lineHeight: 1.2,
    textDecoration: "line-through",
    color: "#BCBCBC",
    mobileViewSize: "1.4rem"
  }, formattedOrigPrice)), /*#__PURE__*/_react["default"].createElement(_spacers.VerticalSpacer, {
    width: ".4rem"
  }), /*#__PURE__*/_react["default"].createElement(_cards.CardText, {
    lineHeight: 1
  }, /*#__PURE__*/_react["default"].createElement(_cards.CardText, {
    bold: true,
    size: "1.6rem",
    lineHeight: 1.2,
    color: "#F4364C",
    mobileViewSize: "1.4rem"
  }, formattedPrice))), /*#__PURE__*/_react["default"].createElement(_spacers.HorizontalSpacer, {
    height: ".3rem"
  }), /*#__PURE__*/_react["default"].createElement(_cards.ProductDetailDiscount, null, percentDiscount, "% OFF")) : /*#__PURE__*/_react["default"].createElement(_cards.CardText, {
    lineHeight: 1
  }, /*#__PURE__*/_react["default"].createElement(_cards.CardText, {
    bold: true,
    size: "1.6rem",
    lineHeight: 1.2,
    mobileViewSize: "1.4rem"
  }, formattedPrice)), /*#__PURE__*/_react["default"].createElement(_spacers.HorizontalSpacer, {
    height: "1rem"
  }), shouldShowQuantity ? /*#__PURE__*/_react["default"].createElement(_cards.CardText, {
    small: true,
    bold: true,
    rightAlign: true,
    mobileViewSize: "1.2rem"
  }, quantity, " ", quantity > 1 ? quantityUnitPlural : quantityUnit) : null);
};

exports.buildPriceQuantityView = buildPriceQuantityView;

var CardTextDetail = function CardTextDetail(props) {
  var _React$createElement;

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_containers.FlexColumn, {
    height: "100%",
    justifyContent: "space-between",
    alignItems: "flex-start",
    padding: props.mainContentWrapperProps.padding || "0.5rem",
    boxSizing: "border-box",
    width: props.containerWidth || "auto",
    opacity: props.isDisabled ? .3 : 1
  }, /*#__PURE__*/_react["default"].createElement(_cards.CardText, {
    small: true,
    bold: true,
    color: _theme["default"]["default"].greyDarker,
    mobileViewSize: props.brandNameFontSize ? props.brandNameFontSize : "1rem",
    textTransform: "uppercase",
    letterSpacing: ".04rem"
  }, props.storeName ? props.storeName : null), /*#__PURE__*/_react["default"].createElement(_spacers.HorizontalSpacer, {
    height: props.brandAndProductNameGap ? props.brandAndProductNameGap : ".5rem"
  }), /*#__PURE__*/_react["default"].createElement(_cards.CardText, (_React$createElement = {
    size: "1.4rem",
    lineHeight: props.productNameLineHeight ? props.productNameLineHeight : "normal",
    fontWeight: props.productNameFontWeight ? props.productNameFontWeight : "700",
    mobileViewSize: "default"
  }, _React$createElement["mobileViewSize"] = props.productNameFontSize ? props.productNameFontSize : "1.2rem", _React$createElement), props.productName), /*#__PURE__*/_react["default"].createElement(_spacers.HorizontalSpacer, {
    height: props.productNameAndSizeGap ? props.productNameAndSizeGap : ".5rem"
  }), /*#__PURE__*/_react["default"].createElement(_containers.FlexRow, {
    justifyContent: "center"
  }, props.branch ? /*#__PURE__*/_react["default"].createElement(_cards.CardText, {
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_cards.CardText, {
    small: true,
    color: _theme["default"]["default"].greyDarker,
    mobileViewSize: "1.2rem"
  }, "Branch:\xA0"), /*#__PURE__*/_react["default"].createElement(_cards.CardText, {
    bold: true,
    small: true,
    color: props.disabledBranch ? _theme["default"]["default"].greyDarker : _theme["default"]["default"].primary,
    mobileViewSize: "1.2rem"
  }, props.branch)) : /*#__PURE__*/_react["default"].createElement(_cards.CardText, null))));
};

exports.CardTextDetail = CardTextDetail;

var ProductDetailsCard = function ProductDetailsCard(props) {
  var _props$cardImageProps = props.cardImageProps,
      cardImageProps = _props$cardImageProps === void 0 ? {} : _props$cardImageProps,
      _props$rightContentPr = props.rightContentProps,
      rightContentProps = _props$rightContentPr === void 0 ? {} : _props$rightContentPr,
      _props$mainContentWra = props.mainContentWrapperProps,
      mainContentWrapperProps = _props$mainContentWra === void 0 ? {} : _props$mainContentWra,
      currentPrice = props.currentPrice,
      originalPrice = props.originalPrice,
      percentDiscount = props.percentDiscount,
      isDisabled = props.isDisabled,
      _props$disclaimer = props.disclaimer,
      disclaimer = _props$disclaimer === void 0 ? null : _props$disclaimer; //

  return /*#__PURE__*/_react["default"].createElement(_rowCard["default"], {
    cardImgSrc: props.cardImgSrc,
    rightContent: props.price || props.quantity ? buildPriceQuantityView(currentPrice, props.quantity, originalPrice, percentDiscount) : null,
    width: props.width || "auto",
    cardImageProps: cardImageProps,
    rightContentProps: rightContentProps,
    isDisabled: isDisabled,
    disclaimer: disclaimer
  }, /*#__PURE__*/_react["default"].createElement(CardTextDetail, _extends({}, props, {
    mainContentWrapperProps: mainContentWrapperProps
  })));
};

exports.ProductDetailsCard = ProductDetailsCard;